import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CommonService } from '../../../../services/common';
import { SalesService } from '../../sales.service';

@Component({
  selector: 'app-ageing-bucket-sale',
  templateUrl: './aging-bucket-sale.component.html',
  styleUrl: './aging-bucket-sale.component.scss'
})
export class AgeingBucketSaleComponent implements OnInit, OnChanges {

  private destroy$ = new Subject<void>();
  saleList: any;

  ageingBuckets: any
  //To capture total of entire sale but ageing bucket wise of all agents
  ageingBucketsTotals: any = {}

  agentList: any
  agentSaleData: any[] = [];
  tempAgentSaleData: any = {};

  saleReportRequest: any = {}

  totalUnitSoldSum: any = 0

  totalAmountSoldUnit: any = 0
  totalAmountReceived: any = 0

  totalBalancedAmountSum: any = 0
  totalAmountReceivedPercentage: any = 0

  constructor(public commonService: CommonService, private saleService: SalesService) { }

  ngOnInit(): void {
    this.getSaleReportDate();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  getSaleReportDate() {
    this.commonService.selectedProjects$
      .pipe(takeUntil(this.destroy$)).subscribe((selectedProject: any) => {
        this.resetAllTotals()
        //project ids has tp go in array as for admin view we may need report for all in single view
        this.saleReportRequest.projectId = [selectedProject?.id]

        this.saleService.getAgeingBucketWiseSale(this.saleReportRequest).subscribe(res => {
          if (res != null && res?.result.length > 0) {
            this.saleList = res?.result;
            //Get unique Ageing buckets to decide columns to create for agign bucket
            this.ageingBuckets = this.commonService.getDistinctKeyValueFromArray(this.saleList, 'ageingBucketName');

            //Get list of unique Agents so that 
            this.agentList = this.commonService.getDistinctKeyValueFromArray(this.saleList, 'agentId');

            this.agentList.forEach((agent: any) => {
              this.tempAgentSaleData = {}
              //We will add only that agent to list who has made at least 1 sale (booking/allotment) in any ageing bucket
              var currentAgentsaleData = this.saleList.filter((x: any) => x.agentId == agent && (x.unitsAllotted > 0 || x.unitsBooked > 0));
              if (currentAgentsaleData.length > 0) {
                this.tempAgentSaleData = {
                  "agentId": agent,
                  "agentName": currentAgentsaleData[0]?.agentName
                }

                //Now we need to prepare data of that agent for all bucket fetched above. 
                // if he has not made in sale in any buceket then it will be shown as 0 else actual sale  
                this.ageingBuckets.forEach((bucket: any) => {
                  //check if sale may in current ageing bucket
                  var saleInCurrAgeing = currentAgentsaleData.filter((x: any) => x.ageingBucketName == bucket)
                  // this.tempAgentSaleData.ageingBucketName = bucket
                  if (saleInCurrAgeing.length > 0) {
                    this.tempAgentSaleData[bucket] = {
                      "unitsSold": saleInCurrAgeing[0].unitsBooked + saleInCurrAgeing[0].unitsAllotted,
                      "amountSold": saleInCurrAgeing[0].amountOfSoldUnits?.toLocaleString('en-IN'),
                      "amountReceived": saleInCurrAgeing[0].amountReceived?.toLocaleString('en-IN'),
                    }

                    this.totalUnitSoldSum = this.totalUnitSoldSum + (saleInCurrAgeing[0]?.unitsBooked
                      + saleInCurrAgeing[0]?.unitsAllotted)
                    this.totalAmountSoldUnit = this.totalAmountSoldUnit + saleInCurrAgeing[0]?.AmountOfSoldUnits
                    this.totalAmountReceived = this.totalAmountReceived + saleInCurrAgeing[0]?.amountReceived
                  }
                  else {
                    this.tempAgentSaleData[bucket] = {
                      "unitsSold": 0,
                      "amountSold": 0,
                      "amountReceived": 0,
                    }
                  }

                  this.ageingBucketsTotals[bucket] =
                  {
                    //for consicutive ittrations of ageing loop. Also will not reset for each agent as it will have total of 
                    //entire sales for all ageing buckets 
                    "TotalSoldUnits": (this.ageingBucketsTotals[bucket]?.TotalSoldUnits != null ? this.ageingBucketsTotals[bucket]?.TotalSoldUnits : 0) + this.tempAgentSaleData[bucket]?.unitsSold,
                    "TotalAmountSold": (this.ageingBucketsTotals[bucket]?.TotalAmountSold != null ? this.ageingBucketsTotals[bucket]?.TotalAmountSold : 0) + (isNaN(saleInCurrAgeing[0]?.amountOfSoldUnits) ? 0 : saleInCurrAgeing[0]?.amountOfSoldUnits),
                    "TotalAmountReceived": (this.ageingBucketsTotals[bucket]?.TotalAmountReceived != null ? this.ageingBucketsTotals[bucket]?.TotalAmountReceived : 0) + (isNaN(saleInCurrAgeing[0]?.amountReceived) ? 0 : saleInCurrAgeing[0]?.amountReceived),
                  }
                })//end of ageing bucket loop
                this.agentSaleData.push(this.tempAgentSaleData)
              }//end of if agent has made any sale condition
            }) //end of agent list loop


            ///run loop again for ageing bucket to format the amount. earlier could not do since that was being used in calculation
            this.ageingBuckets.forEach((bucket: any) => {
              this.ageingBucketsTotals[bucket].TotalAmountSold = this.ageingBucketsTotals[bucket].TotalAmountSold?.toLocaleString('en-IN')
              this.ageingBucketsTotals[bucket].TotalAmountReceived = this.ageingBucketsTotals[bucket].TotalAmountReceived?.toLocaleString('en-IN')
            });

          }//end of res.result condition
        })
      });
  }

  resetAllTotals() {
    this.ageingBucketsTotals = []
    this.totalUnitSoldSum = 0
    this.totalAmountSoldUnit = 0
    this.totalAmountReceived = 0
    this.totalBalancedAmountSum = 0
    this.totalAmountReceivedPercentage = 0
  }

  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
